module.exports = __webpack_public_path__ + "img/c05_buildingtechromainvicta_Normal_ua.8aaf46ea.webp";